export const PRE_ASSESSMENTS_CONTENT_PASS_THRESHOLD = 0.5;